let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kg7ba")).then(() => parcelRequire('kgLmS'));